---
version: "v1.2"
title: "Export reports to PDF/CSV, and share them with a public link"
date: 2026-08-01
excerpt: "Download any scan report as a PDF or CSV, and share a read-only view of it with anyone — no DebtDrone account required."
---

## Downloadable reports

Every scan report now has a **Download** menu with two options:

- **PDF** — a print-formatted version of the full report (health grade, severity/type breakdowns, hotspot files, and the top issues by debt hours), ready to attach to a doc or send in an email.
- **CSV** — the complete issue list for that run, one row per issue, for further analysis in a spreadsheet.

## Share a report publicly

Click **Share** on any report to generate a public link. Anyone with the link can view a read-only version of that report — the same data, in a simplified view with no sign-in required. This is useful for looping in a stakeholder, a client, or anyone else who doesn't have (or need) a DebtDrone account.

Share links can be revoked or regenerated at any time from the same dialog; regenerating immediately invalidates the previous link.
